import { useSelector } from "react-redux";

import type { IChosenItem } from "app/components/compare/WebsiteQueryBar/WebsitePageQueryBarUtils";
import type { INRoutingState } from "app/reducers/_reducers/routingReducer";
import type { RootState } from "single-spa/store/types";

const selectChosenItems = (state: RootState): IChosenItem[] => {
    const routingState = state?.routing as INRoutingState | undefined;
    return (routingState?.chosenItems ?? []) as IChosenItem[];
};

/**
 * Hook to access chosen items from WebsiteQueryBar using modern React patterns
 * Uses Redux selector to get current selected items from the store
 */
export const useWebsiteQueryBarItems = (): IChosenItem[] => {
    return useSelector(selectChosenItems);
};
